import React, { ReactNode } from "react";
import ContinueButton from "../Buttons/ContinueButton";
import ParrotLogo from "@/assets/ParrotLogo.png";
import { getPlatform } from "@/lib/iap";
import SpeechBubble from "./SpeechBubble";

interface InstructionsScreenProps {
  onContinue: () => void;
  text: ReactNode;
}

const InstructionsScreen: React.FC<InstructionsScreenProps> = ({
  onContinue,
  text,
}) => {
  const platform = getPlatform();
  return (
    <div className="appPadding py-0 flex flex-col h-full w-full overflow-hidden">
      <div className="p-6 w-full flex flex-col flex-grow items-center justify-center gap-6">
        <div className="relative w-full flex justify-center text-lg">
          <SpeechBubble>
            {text}
          </SpeechBubble>
        </div>
        <img
          src={ParrotLogo}
          alt="Parrot Logo"
          className="w-[140px] h-auto"
        />
      </div>
      <div
        className={`flex justify-center items-center ${
          platform === "web" ? "bottom-padding-web" : "pb-6"
        }`}
        style={{ pointerEvents: "auto" }}
      >
        <ContinueButton onClick={onContinue} text="Continue" />
      </div>
    </div>
  );
};

export default InstructionsScreen;
